// This icon file is generated automatically.
var PCreditCardOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M13.5 1.5H.5A.5.5 0 000 2v10c0 .28.22.5.5.5h13a.5.5 0 00.5-.5V2a.5.5 0 00-.5-.5zM1.12 2.63h11.75V4.5H1.13V2.62zm11.75 8.75H1.13v-5.5h11.75v5.5zm-3.7-1h2.58c.07 0 .13-.06.13-.13V9.12a.13.13 0 00-.13-.12H9.17a.13.13 0 00-.12.13v1.12c0 .07.05.13.12.13z", "fill-rule": "nonzero" } }] }, "name": "p-credit-card", "theme": "outlined" };
export default PCreditCardOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PCreditCardOutlined.js
// module id = 3310
// module chunks = 0